import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { IconPlus, IconDelete } from "@sfx/icons";

var prefix = 'sfx-react-ui-button';
export var Button = /*#__PURE__*/function (_Component) {
  _inherits(Button, _Component);

  var _super = _createSuper(Button);

  function Button() {
    var _this;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getIcon", function () {
      if (_this.props.icon === 'add') {
        return /*#__PURE__*/React.createElement(IconPlus, {
          size: "16"
        });
      } else if (_this.props.icon === 'delete') {
        return /*#__PURE__*/React.createElement(IconDelete, {
          size: "16"
        });
      } else if (_this.props.icon) {
        return _this.props.icon;
      } else {
        return null;
      }
    });

    return _this;
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return /*#__PURE__*/React.createElement("button", _extends({}, this.props, {
        className: this.props.className ? "".concat(prefix, "-btn ").concat(this.props.className) : "".concat(prefix, "-btn"),
        "data-btype": this.props.btype || 'important'
      }), /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-btn-content")
      }, this.getIcon(), this.props.icon ? /*#__PURE__*/React.createElement("span", {
        style: {
          marginLeft: "5px"
        }
      }, children) : children));
    }
  }]);

  return Button;
}(Component);

_defineProperty(Button, "defaultProps", {
  icon: null
});

export default Button;
export var SFxButton = /*#__PURE__*/function (_Component2) {
  _inherits(SFxButton, _Component2);

  var _super2 = _createSuper(SFxButton);

  function SFxButton() {
    _classCallCheck(this, SFxButton);

    return _super2.apply(this, arguments);
  }

  _createClass(SFxButton, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Button, this.props, this.props.children);
    }
  }]);

  return SFxButton;
}(Component);
export var SFxButtonGroup = /*#__PURE__*/function (_Component3) {
  _inherits(SFxButtonGroup, _Component3);

  var _super3 = _createSuper(SFxButtonGroup);

  function SFxButtonGroup() {
    _classCallCheck(this, SFxButtonGroup);

    return _super3.apply(this, arguments);
  }

  _createClass(SFxButtonGroup, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-btn-group")
      }, this.props.children);
    }
  }]);

  return SFxButtonGroup;
}(Component);
export var SFxButtonGroupWithIcon = /*#__PURE__*/function (_Component4) {
  _inherits(SFxButtonGroupWithIcon, _Component4);

  var _super4 = _createSuper(SFxButtonGroupWithIcon);

  function SFxButtonGroupWithIcon() {
    _classCallCheck(this, SFxButtonGroupWithIcon);

    return _super4.apply(this, arguments);
  }

  _createClass(SFxButtonGroupWithIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-btn-group-with-icon")
      }, this.props.children);
    }
  }]);

  return SFxButtonGroupWithIcon;
}(Component);